import { useEffect, useState } from 'react';
import Mark from './Mark';

export default function Nav({ sections, active }) {
  const [open, setOpen] = useState(false);
  const [solid, setSolid] = useState(false);

  useEffect(() => {
    const onScroll = () => setSolid(window.scrollY > 40);
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  useEffect(() => {
    document.body.style.overflow = open ? 'hidden' : '';
    const onKey = (e) => { if (e.key === 'Escape') setOpen(false); };
    window.addEventListener('keydown', onKey);
    return () => { window.removeEventListener('keydown', onKey); document.body.style.overflow = ''; };
  }, [open]);

  const close = () => setOpen(false);

  return (
    <header className={`nav ${solid ? 'is-solid' : ''} ${open ? 'is-open' : ''}`}>
      <div className="nav-bar">
        <a className="nav-brand" href="#top" onClick={close} aria-label="Ize Trio, back to top">
          <Mark className="nav-mark" />
          <span>Ize Trio</span>
        </a>

        <nav className="nav-links" aria-label="Sections">
          {sections.map((s) => (
            <a key={s.id} href={`#${s.id}`} aria-current={active === s.id ? 'true' : undefined}>{s.label}</a>
          ))}
        </nav>

        <button
          type="button"
          className="nav-toggle"
          aria-expanded={open}
          aria-controls="site-menu"
          onClick={() => setOpen(!open)}
        >
          <span className="nav-toggle-bars" aria-hidden="true"><i /><i /></span>
          <span className="sr-only">{open ? 'Close menu' : 'Open menu'}</span>
        </button>
      </div>

      {open && (
        <nav id="site-menu" className="nav-menu" aria-label="Sections">
          {sections.map((s) => (
            <a key={s.id} href={`#${s.id}`} onClick={close}>{s.label}</a>
          ))}
        </nav>
      )}
    </header>
  );
}
